// Vuex records module mutations
import {
  FILL_LIST,
  SET_FILTERING_CRITERIA,
  SET_PAGE,
  FILL_LIST_EMPTY_CLIENTS,
  SET_RECORDS_PER_PAGE,
} from './mutations-types';

export default {
  [FILL_LIST](state, payload) {
    const _state = state;
    _state.list.records = payload.records;
    _state.list.total = payload.total;
  },
  [FILL_LIST_EMPTY_CLIENTS](state) {
    const _state = state;
    _state.isEmptyClients = true;
  },
  [SET_FILTERING_CRITERIA](state, payload) {
    const _state = state;
    _state.filteringCriteria = payload;
  },
  [SET_PAGE](state, payload) {
    const _state = state;
    _state.list.page = payload.page;
  },
  [SET_RECORDS_PER_PAGE](state, payload) {
    const _state = state;
    _state.recordsPerPage = payload.recordsPerPage;
  },
};
